module.exports = __webpack_public_path__ + "img/original-exam.0d1c3455.png";